import React from 'react';
import AllFellowshipsTable from '../components/HomePage/AllFellowshipsTable';

const FellowshipsPage = () => {
  return (
    <div className="fellowships-page">
      <AllFellowshipsTable />
    </div>
  );
};

export default FellowshipsPage;
